import domReady from "@wordpress/dom-ready";

import Glide,
{
  Controls,
  Breakpoints,
  Keyboard,
  Swipe
} from '@glidejs/glide/dist/glide.modular.esm';

domReady(() => {
  // .block-carousel
  const options = {
    type: 'carousel',
    perView: 2,
    gap: '50px',
    breakpoints: {
      800: {
        perView: 1,
      },

      1200: {
        gap: '10px',
      }
    }
  }

  document.querySelectorAll('.glide')
    .forEach((glide) => {
      new Glide(glide, options)
        .mount({ Controls, Breakpoints, Keyboard, Swipe })
    });

  // .block-video
  document.querySelectorAll('.block-video')
    .forEach((block) => {
      const fades = block.querySelectorAll('.fade');
      const overlayWrap = block.querySelector('.block-video__overlay-wrap');
      const video = block.querySelector('.block-video__video');
      const playButton = block.querySelector('.play-button');

      // Event for play/pause
      playButton.addEventListener('click', handlePlayVideo);
      overlayWrap.addEventListener('click', handlePlayVideo);

      // Hide and show overlay
      video.addEventListener('pause', () => {
        handleToggleTransition(fades, 'fade');
      });

      function handlePlayVideo() {
        // Play video
        video.play();
        handleToggleTransition(fades, 'fade');
      }
    });

  function handleToggleTransition(items, transition) {
    items.forEach((item) => {
      if (item.classList.contains(`${transition}-in`)) {
        item.classList.replace(`${transition}-in`, `${transition}-out`);
      } else {
        item.classList.replace(`${transition}-out`, `${transition}-in`);
      }
    });
  }

});
